<template>
    <el-dialog
        :visible="visible"
        ref="DetailDialog"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="accounting-item-template-import-dialog ah-detail-dialog"
        top="5vh"
        width="1000px"
        append-to-body
        @open="onOpen"
        @close="onClose()"
    >
        <template slot="title">
            <span>會計科目範本匯入</span>
            <span v-if="type === 'detail'">- 明細科目</span>
            <span v-if="type === 'reconciliation'">- 統制科目</span>
        </template>
        <div>
            <div class="top-info-bar">
                <el-radio-group v-model="displayMode" size="small" :disabled="isLoading">
                    <el-radio-button label="all">全部 ({{ allItemsCount }})</el-radio-button>
                    <el-radio-button label="notExistOnly">可匯入 ({{ notExistItemsCount }})</el-radio-button>
                </el-radio-group>
                <div>
                    <el-button size="small" icon="el-icon-refresh" @click="onOpen" :disabled="isLoading">重新整理</el-button>
                </div>
            </div>
            <el-table
                v-if="type === 'detail'"
                ref="accTable"
                v-loading="isLoading"
                :data="displayMode === 'notExistOnly' ? notExistsAccItems : templateAccItems"
                :row-class-name="tableRowClassName"
                row-id="sno"
                empty-text="無可用項目"
                size="mini"
                height="60vh"
                @selection-change='onDetailTableSelectionChange'
                @row-click="handleRowClick"
                key="accTable"
            >
                <el-table-column type="selection" :selectable="checkRowSelectable" width="55" />
                <el-table-column prop="accno" label="明細科目代號" width="100" />
                <el-table-column prop="accnam" label="明細科目名稱" />
                <el-table-column prop="accnaM_E" label="明細科目名稱（英文）" />
                <el-table-column prop="gccno" label="統治科目代號" width="100" />
                <el-table-column prop="dC_TYP" label="屬性" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.dC_TYP === 1">借</div>
                        <div v-if="scope.row.dC_TYP === 2">貸</div>
                    </template>
                </el-table-column>
                <el-table-column prop="ismonth" label="月計科目" width="80">
                    <template slot-scope="scope">
                        <i v-if="scope.row.ismonth" class="el-icon-check"></i>
                    </template>
                </el-table-column>
            </el-table>
            <el-table
                v-if="type === 'reconciliation'"
                ref="gccTable"
                v-loading="isLoading"
                :data="displayMode === 'notExistOnly' ? notExistsGccItems : templateGccItems"
                :row-class-name="tableRowClassName"
                row-id="sno"
                empty-text="無可用項目"
                size="mini"
                height="400"
                @selection-change="onReconciliationTableSelectionChange"
                @row-click="handleRowClick"
                key="gccTable"
            >
                <el-table-column type="selection" :selectable="checkRowSelectable" width="55" />
                <el-table-column prop="gccno" label="統治科目代號" width="100" />
                <el-table-column prop="gccnam" label="統治科目名稱"  />
                <el-table-column prop="gccnaM_E" label="統治科目名稱（英文）"/>
                <el-table-column prop="dC_TYP" label="屬性" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.dC_TYP === 1">借</div>
                        <div v-if="scope.row.dC_TYP === 2">貸</div>
                    </template>
                </el-table-column>
                <el-table-column prop="ismonth" label="月計科目" width="80">
                    <template slot-scope="scope">
                        <i v-if="scope.row.ismonth" class="el-icon-check"></i>
                    </template>
                </el-table-column>
            </el-table>
            <div class="dialog-footer">
                <div style="display: flex; gap: 15px;">
                    <span>已勾選 {{ selectedCount }} 項</span>
                    <el-button v-if="selectedCount > 0" size="mini" @click="clearSelection" :disabled="isLoading">取消選取</el-button>
                </div>
                <el-button
                    size="small"
                    type="primary"
                    :disabled="selectedCount === 0"
                    @click="onImportItems"
                >
                    <span>匯入已勾選項目</span>
                    <span v-if="selectedCount > 0"> ({{ selectedCount }})</span>
                </el-button>
            </div>
        </div>
        <div v-if="isImporting" class="progress-view">
            <div class="progress-panel">
                <div class="panel-title">匯入中</div>
                <div class="progress-bar">
                    <el-progress :percentage="processPercentage" :show-text="false" :stroke-width="10"></el-progress>
                </div>
                <div class="progress-msg">{{ this.processMsg }}</div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'detail', // detail: 明細科目, reconciliation: 統制科目
        },
        data: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            isImporting: false,
            displayMode: 'all', // 顯示模式：all, notExistOnly
            existAccItems: [], // 已存在的明細科目清單
            existGccItems: [], // 已存在的統制科目清單
            existAccnoList: [], // 已存在的明細科目accno清單（供快速查詢是否存在）
            existGccnoList: [], // 已存在的統制科目gccno清單（供快速查詢是否存在）
            existGccnoSnoMap: new Map(), // 已存在的統制科目 gccno 和 sno 對照表（供新增明細科目時，快速查詢所屬統制科目的sno）
            templateAccItems: [], // 明細科目範本清單
            templateGccItems: [], // 統制科目範本清單
            selectedAccItems: [], // 已勾選的明細科目
            selectedGccItems: [], // 已勾選的統制科目
            processPercentage: 0, // 匯入進度百分比
            processMsg: '', // 匯入進度文字訊息
        };
    },
    computed: {
        notExistsAccItems() {
            return this.templateAccItems.filter((item) => !item.exists);
        },
        notExistsGccItems() {
            return this.templateGccItems.filter((item) => !item.exists);
        },
        allItemsCount() {
            if (this.type === 'detail') return this.templateAccItems.length;
            if (this.type === 'reconciliation') return this.templateGccItems.length;
            return 0;
        },
        notExistItemsCount() {
            if (this.type === 'detail') return this.notExistsAccItems.length;
            if (this.type === 'reconciliation') return this.notExistsGccItems.length;
            return 0;
        },
        selectedCount() {
            if (this.type === 'detail') return this.selectedAccItems.length;
            if (this.type === 'reconciliation') return this.selectedGccItems.length;
            return 0;
        },
    },
    methods: {
        async onOpen() {
            this.isLoading = true;

            // 取得目前已存在的科目
            this.existAccItems = await this.fetchExistAccData();
            this.existGccItems = await this.fetchExistGccData();

            // 轉換為代號列表，供快速查詢是否已存在 ex: ["1126", "1130", "1131",...]
            this.existAccnoList = this.existAccItems.map((item) => item.accno);
            this.existGccnoList = this.existGccItems.map((item) => item.gccno);

            // 轉換為 Map(Gccno, sno) 對照表，供快速查詢 Gccno 對應的 sno, 於明細科目新增時使用
            this.existGccnoSnoMap = this.generateGccnoSnoMap(this.existGccItems);

            // 取得範本科目清單（明細＆統制）
            await this.fetchTemplateDatas();

            this.isLoading = false;
        },

        onClose(refresh) {
            this.$emit('close', refresh);
        },

        // 項目是否可勾選（判斷 accno 是否已存在）
        checkRowSelectable(row) {
            return !row.exists;
        },

        // 切換該行的選取狀態
        handleRowClick(row) {
            if (row.exists) return; // 已存在的不可勾選

            let targetTable = null;
            if (this.type === 'detail') targetTable = this.$refs.accTable;
            if (this.type === 'reconciliation') targetTable = this.$refs.gccTable;

            if (targetTable) {
                targetTable.toggleRowSelection(row);
            }
        },

        // 明細科目表格勾選時觸發
        onDetailTableSelectionChange(selectedItems) {
            this.selectedAccItems = selectedItems;
        },

        // 統制科目表格勾選時觸發
        onReconciliationTableSelectionChange(selectedItems) {
            this.selectedGccItems = selectedItems;
        },

        // 清除勾選
        clearSelection() {
            if (this.type === 'detail') this.$refs.accTable.clearSelection();
            if (this.type === 'reconciliation') this.$refs.gccTable.clearSelection();
        },

        // 產生統制科目的 gccno 和 sno 對照 Map, 供新增明細科目時，快速查詢所屬統制科目的sno
        generateGccnoSnoMap(gccItems) {
            const map = new Map();
            for (let i = 0; i < gccItems.length; i += 1) {
                map.set(gccItems[i].gccno, gccItems[i].sno);
            }
            return map;
        },

        // 取得會計科目範本清單（明細＋統制）
        async fetchTemplateDatas() {
            try {
                const resp = await this.$api({
                    url: '/Tool/GetSubjectTemplate',
                    method: 'GET',
                });
                this.templateAccItems = this.applyWhetherExistsProp(resp.data.accItems, 'accno');
                this.templateGccItems = this.applyWhetherExistsProp(resp.data.gccItems, 'gccno');
            } catch (ex) {
                console.log(ex);
            }
        },

        // 增加是否已存在的欄位到列表物件中
        applyWhetherExistsProp(inputItems, checkColumn) {
            // 複製
            const outputItems = [...inputItems];

            // 設定比對清單
            let checkList = [];
            if (checkColumn === 'accno') checkList = this.existAccnoList;
            if (checkColumn === 'gccno') checkList = this.existGccnoList;

            // 逐一比對，並添加 .exists 參數
            for (let i = 0; i < outputItems.length; i += 1) {
                outputItems[i].exists = checkList.includes(outputItems[i][checkColumn]);
            }
            return outputItems;
        },

        // 取得已存在的明細科目列表
        async fetchExistAccData() {
            let datas = null;
            try {
                const resp = await this.$api({
                    url: '/AccountingSettingPage/GetAccountingSettings',
                    method: 'GET',
                });
                datas = resp.data.settings;
            } catch (ex) {
                console.log(ex);
            }
            return datas;
        },

        // 取得已存在的統制科目列表
        async fetchExistGccData() {
            let datas = null;
            try {
                const resp = await this.$api({
                    url: '/ReconciliationAccount/Query',
                    method: 'GET',
                });
                datas = resp.data.settings;
            } catch (ex) {
                console.log(ex);
            }
            return datas;
        },

        // 重新載入統制科目相關資料
        async reloadExistGccDatas() {
            this.existGccItems = await this.fetchExistGccData();
            this.existGccnoList = this.existGccItems.map((item) => item.gccno);
            this.existGccnoSnoMap = this.generateGccnoSnoMap(this.existGccItems);
        },

        async onImportItems() {
            if (this.type === 'detail') this.onImportAccItems();
            if (this.type === 'reconciliation') this.onImportGccItems();
        },

        async onImportAccItems() {
            this.isImporting = true;
            this.processPercentage = 0;
            this.processMsg = '匯入中';

            // 先取得勾選項目有用到，但不存在的統制科目
            const needAddGccnoList = this.getNotExistGccnoListFromAcc(this.selectedAccItems);
            if (needAddGccnoList.length > 0) {
                await this.importGccItemsByGccnoList(needAddGccnoList);
                await this.reloadExistGccDatas();
            }

            // 每一個勾選項目
            const selectedCount = this.selectedAccItems.length;
            for (let i = 0; i < selectedCount; i += 1) {
                try {
                    const data = this.selectedAccItems[i];
                    // eslint-disable-next-line no-await-in-loop
                    await this.addAccItem(data);
                    this.processMsg = `(${i} / ${selectedCount}) 新增明細科目：${data.accno} ${data.accnam}`;
                } catch (ex) {
                    console.error(ex);
                }
                this.processPercentage = (i / selectedCount) * 100;
            }

            this.processPercentage = 100;
            this.processMsg = '';
            setTimeout(() => {
                this.isImporting = false;
                this.processMsg = '';
                this.onClose(true);
            }, 500);
        },

        getNotExistGccnoListFromAcc(accItems) {
            const notExistGccnoList = [];
            for (let i = 0; i < accItems.length; i += 1) {
                if (!this.existGccnoList.includes(accItems[i].gccno)) {
                    if (!notExistGccnoList.includes(accItems[i].gccno)) {
                        notExistGccnoList.push(accItems[i].gccno);
                    }
                }
            }
            return notExistGccnoList;
        },

        async addAccItem(data) {
            // 新增明細科目
            await this.$api({
                url: '/AccountingSettingPage/AddSetting',
                method: 'POST',
                data: {
                    typ: data.typ,
                    accno: data.accno,
                    accnam: data.accnam,
                    accnaM_E: data.accnaM_E,
                    gccnO_SNO: this.existGccnoSnoMap.get(data.gccno),
                    ismonth: data.ismonth,
                },
            });
        },

        // 新增統制科目
        async addGccItem(data) {
            await this.$api({
                url: '/ReconciliationAccount/New',
                method: 'POST',
                data: {
                    gccno: data.gccno,
                    gccnam: data.gccnam,
                    gccnaM_E: data.gccnaM_E,
                    dC_TYP: data.dC_TYP,
                    gaap: data.gaap,
                    defaultAccount: data.defaultAccount,
                    typ: data.typ,
                },
            });
        },

        // 批次新增統制科目
        async importGccItemsByGccnoList(gccnoList) {
            for (let i = 0; i < gccnoList.length; i += 1) {
                const gccnoToAdd = gccnoList[i];
                const gccItem = this.templateGccItems.find((item) => item.gccno === gccnoToAdd);
                if (gccItem) {
                    // eslint-disable-next-line no-await-in-loop
                    await this.addGccItem(gccItem);
                }
            }
        },

        async onImportGccItems() {
            this.isImporting = true;
            this.processPercentage = 0;
            this.processMsg = '匯入中';

            // 每一個勾選項目
            const selectedCount = this.selectedGccItems.length;
            for (let i = 0; i < selectedCount; i += 1) {
                try {
                    const data = this.selectedGccItems[i];
                    // eslint-disable-next-line no-await-in-loop
                    await this.addGccItem(data);
                    this.processMsg = `(${i} / ${selectedCount}) 新增統制科目：${data.gccno} ${data.gccnam}`;
                } catch (ex) {
                    console.error(ex);
                }
                this.processPercentage = (i / selectedCount) * 100;
            }

            this.processPercentage = 100;
            this.processMsg = '';
            setTimeout(() => {
                this.isImporting = false;
                this.processMsg = '';
                this.onClose(true);
            }, 500);
        },

        tableRowClassName({ row }) {
            if (!row.exists) {
                return 'not-exists-row';
            }
            return '';
        },
    },
};
</script>
<style lang="scss">
.accounting-item-template-import-dialog {
    .el-button.compact-button {
        padding: 5px 12px;
    }
    .top-info-bar {
        padding: 10px;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
    }

    .dialog-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        font-size: 10pt;
        color: #888;
    }

    // .el-table .el-table__row:hover > td {
    //     background-color: #fcfcfc;
    // }

    .el-table .not-exists-row {
        font-weight: bold;
        color: #463cb2;
    }

    .progress-view {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 20;

        >.progress-panel {
            width: 400px;
            background-color: #fff;
            padding: 25px;
            border-radius: 8px;

            .panel-title {
                font-size: 11pt;
                font-weight: bold;
                color: #000;
                margin-bottom: 15px;
            }
            .progress-msg {
                margin-top: 10px;
                font-size: 9pt;
                color: #666;
            }
        }
    }
}
</style>
